<template>
    <DeepiBaseField
        :hasFocus="hasFocus"
        :isValid="textArea?.isValid ?? true"
        :errorMessages="textArea?.errorMessages ?? []"
        :label="props.label"
        :hint="props.hint"
        :forceDetails="props.forceDetails"
        :rules="props.rules"
        :variant="props.variant"
    >
        <v-textarea
            ref="textArea"
            class="deepi-text-area"
            variant="solo"
            validateOn="lazy blur"
            :flat="true"
            :noResize="true"
            :hideDetails="true"
            :class="classes"
            :style="style"
            :rules="props.rules"
            :placeholder="props.placeholder"
            :rows="props.rows"
            :modelValue="props.modelValue"
            @update:modelValue="emit('update:modelValue', $event)"
            @update:focused="hasFocus = $event"
            @keydown.stop="props.validateKeyDown?.($event)"
        />
    </DeepiBaseField>
</template>

<script setup lang="ts">
import { computed, ref, type StyleValue } from 'vue';
import { type VTextarea } from 'vuetify/components';

import DeepiBaseField from '../baseField/DeepiBaseField.vue';

export interface DeepiTextAreaProps {
    label?: string;
    placeholder?: string;
    hint?: string;
    forceDetails?: boolean;
    variant?: 'primary' | 'secondary' | 'tertiary';
    rules?: ((value: any) => boolean | string)[];
    rows?: number;
    validateKeyDown?: (event: KeyboardEvent) => void;
    modelValue?: string;
};

const props = withDefaults(defineProps<DeepiTextAreaProps>(), {
    variant: 'tertiary',
    rows: 3
});

const emit = defineEmits(['update:modelValue']);

const textArea = ref<InstanceType<typeof VTextarea>>();

const hasFocus = ref(false);

const classes = computed((): string[] => {
    const classes: string[] = [props.variant];
    /// The comparison is important here because isValid is null before first validation
    if (textArea.value && textArea.value.isValid === false) {
        classes.push('error');
    }
    return classes;
});

const style = computed((): StyleValue => ({
    '--height': `${20 + props.rows * 18}px`
}));
</script>

<style scoped lang="scss">
@use 'DeepiTextArea.scss';
</style>